import { Injectable } from '@angular/core';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { ButtonTheme } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class VmaPopupSettingService extends PopupSettingService {
  singleButtonTheme: ButtonTheme = 'secondary';
  userIdleDialogButtonTheme: ButtonTheme = 'outline-primary';
}
